<!--------------Header Section-------------->
<div id="displayLogo" class="header-image-top">
    <nav class="navbar navbar-expand-md navbar-light nav-top-header">
      <a class="navbar-brand abs"><img src="../assets/img/emirates-logo.png"></a>
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <a class="nav-link"><img src="assets/img/dubai-gov-logo.png"></a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link"><img src="assets/img/dewa-logo.png"></a>
        </li>
      </ul>
    </nav>
</div>
